import { Center } from 'src/app/models/center-model/center.model';
import { MenuSection } from 'src/app/models/menu-section-model/menu-section.model';

export class Rol {

    private centerList: Center[];
    private companyInternalId: string;
    private menuOptions: MenuSection[];
    private roleFatherInternalId: string;
    private roleInternalId: string;
    private rolename: string;

    constructor(centerList?: Center[], companyInternalId?: string, menuOptions?: MenuSection[], roleFatherInternalId?: string, roleInternalId?: string, rolename?: string) {
        this.centerList = centerList;
        this.companyInternalId = companyInternalId;
        this.menuOptions = menuOptions;
        this.roleFatherInternalId = roleFatherInternalId;
        this.roleInternalId = roleInternalId;
        this.rolename = rolename;
    }

    public get CenterList() {
        return this.centerList;
    }
    public get CompanyInternalId() {
        return this.companyInternalId;
    }
    public get MenuOptions() {
        return this.menuOptions;
    }
    public get RoleFatherInternalId() {
        return this.roleFatherInternalId;
    }
    public get RoleInternalId() {
        return this.roleInternalId;
    }
    public get Rolename() {
        return this.rolename;
    }

    public set CenterList(centerList) {
        this.centerList = centerList;
    }
    public set CompanyInternalId(companyInternalId) {
        this.companyInternalId = companyInternalId;
    }
    public set MenuOptions(menuOptions) {
        this.menuOptions = menuOptions;
    }
    public set RoleFatherInternalId(roleFatherInternalId) {
        this.roleFatherInternalId = roleFatherInternalId;
    }
    public set RoleInternalId(roleInternalId) {
        this.roleInternalId = roleInternalId;
    }
    public set Rolename(rolename) {
        this.rolename = rolename;
    }
}
